<div fxLayout="column" fxFlex="grow" class="dialog__container">
  <div class="labels">
    <h3 class="mat-h3">Print Specimen(s)</h3>
    <h4 class="mat-h4 m-0 t-b">Requisition: {{data?.RequisitionID}}</h4>
  </div>
  <div class="table_container">
    <span mat-dialog-content class="tableContents">

      <table mat-table [dataSource]="dataSource" aria-describedby="printSpecimenDialog" class="specimentTable">

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select" class="selectAll">
          <th mat-header-cell *matHeaderCellDef id="selectAll">
            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Specimen Column -->
        <ng-container matColumnDef="specimen" class="specimenCol">
          <th mat-header-cell *matHeaderCellDef id="specimenCol"> Specimen(s) </th>
          <td class="text-left" mat-cell *matCellDef="let element"> {{element.SpecimenKitId}} {{' - '}} {{(element.SpecimenType ?
          element.SpecimenType : 'N/A')}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
        </tr>
      </table>

    </span>
    @if (isLoading) {
      <div style="justify-content: center;display: flex;">
        <mat-progress-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="40" [value]="'warn'">
        </mat-progress-spinner>
      </div>
    }
  </div>
  <div class="footer">
    <footer class="printSpecimenFooter">
      <div class="actions" fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="30px" fxLayout.xs="column"
        fxLayout.sm="column">
        <button fxFlex="45" mat-button color="primary" (click)="close()">Cancel</button>
        <button fxFlex="45" mat-raised-button color="primary"
        [disabled]="isLoading || !selection || selection.selected.length == 0" (click)="printLabels()">Print</button>
      </div>
    </footer>
  </div>
</div>